// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"_3fim0Fz_QJxyysu1QQynwx","alert":"_2EGrALsR5b1ZQoX7YmfVlL","profileCard":"_2PWRx_k9OksYoO6HDWNuCw"};